import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  CheckboxField,
  Flex,
  Icon,
  Loader,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  View} from "@aws-amplify/ui-react";
import { getTaskUserListAPI, getUsersListAPI } from "../../data/api";
import TaskCard from "../task/TaskCard";
import { getUserRoleLabel } from "@/data/interfaces";
import { MdEdit, MdLock, MdLockOpen } from "react-icons/md";
import { NavLink } from "react-router-dom";
import users from ".";
import { format } from "date-fns";
import { Modal } from "react-bootstrap";
import TaskAssignModal from "./TaskAssignModal";

const RisorseTaskList = (props) => {
  const [taskList, setTaskList] = useState([]);
  const [selectedTaskList, setSelectedTaskList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [emptyState, setEmptyState] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const pageSize = 10;
  const observer = useRef<IntersectionObserver | null>(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const closeAssignModal = () => setShowAssignModal(false);
  const [assignType, setAssignType] = useState('all');
  const openAssignModal = (type) => {
    setAssignType(type)
    setShowAssignModal(true);
  }

  const selectTask = (taskId) => {
    if(!selectedTaskList.includes(taskId)) {
      setSelectedTaskList([...selectedTaskList, taskId]);
    } else {
        setSelectedTaskList(selectedTaskList.filter(t => t != taskId))
    }
  };

  const loadNextPage = async () => {
    if(!isLastPage){
      getTaskList();
    }
  };

  const getTaskList = async () => {    
    try{
      setLoading(true);
      setEmptyState(false);
      setError(false);
      const taskListPage = await getTaskUserListAPI(props.username, taskList.length, pageSize)
      setIsLastPage(taskListPage.last);
      setTaskList([...taskList, ...taskListPage.tasks]);
      setLoading(false);
    } catch (e) {
      if(e.statusCode === 404){
        if(taskList.length === 0){
          console.log('No task found for user ', e);
          setEmptyState(true);
        } else {
          setIsLastPage(true);
        }
      } else {
        console.log('Loading task list failed ', e);
        setError(true);
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    getTaskList();
  }, [])  

  const lastItemRef = useCallback((node: HTMLDivElement) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        loadNextPage();
      }
    });

    if (node) observer.current.observe(node);
  }, [loading, loadNextPage]);

  return (
    <>
    <Modal show={showAssignModal} onHide={closeAssignModal}>
      <Modal.Header closeButton>
        <Modal.Title>{assignType === 'all' ? 'Riassegnazione di tutti i task' : 'Riassegnazione task selezionati'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TaskAssignModal user={props.username} type={assignType} onAssign={() => {closeAssignModal(); props.onUpdate();}} tasks={selectedTaskList}></TaskAssignModal>
      </Modal.Body>
    </Modal>
    <View
      backgroundColor="var(--amplify-colors-white)"
      borderRadius="6px"
      maxWidth="100%"
      padding="1rem"
      marginBottom="20px"
    >
      {
        error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
        emptyState ? <Alert variation="info">Nessun task trovato</Alert> :
        loading && taskList.length === 0 ? <Loader/> : 
        <ScrollView width="100%">
            <View textAlign={"right"} marginBottom="20px">
                <Button onClick={() => openAssignModal('selected')} variation="primary" disabled={selectedTaskList.length < 1}>Riassegna selezionati</Button>
                <Button onClick={() => openAssignModal('all')} marginLeft="20px" disabled={taskList.length < 1}>Riassegna tutti</Button>
            </View>
            <Table caption="" highlightOnHover={true}>
                <TableHead>
                    <TableRow>
                        <TableCell as="th"></TableCell>
                        <TableCell as="th">Creato da</TableCell>
                        <TableCell as="th">Testo</TableCell>
                        <TableCell as="th">Data consegna</TableCell>
                        <TableCell as="th">Assegnatari</TableCell>
                        <TableCell as="th">Completato</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {taskList.map(task =>  {
                    return (
                        <TableRow key={task.id} onClick={() => selectTask(task.id)} style={{"cursor":"pointer"}}>
                            <TableCell>
                              <CheckboxField 
                                label={task.id} 
                                labelHidden 
                                name={task.id} 
                                checked={selectedTaskList.includes(task.id)}
                                onClick={(e) => e.stopPropagation()}>
                              </CheckboxField>
                            </TableCell>
                            <TableCell>{task.owner}</TableCell>
                            <TableCell>{task.testo}</TableCell>
                            <TableCell>{format(task.dataTask, 'dd/MM/yyyy')}</TableCell>
                            <TableCell>{task.operatori.join(', ')}</TableCell>
                            <TableCell>{task.completato ? 'Sì' : 'No'}</TableCell>
                        </TableRow>
                    );
                    })}
                </TableBody>
            </Table>
            <>
            { <div ref={lastItemRef} /> } 
            { loading && <Loader/> } 
            </>
        </ScrollView>
      }
    </View>
    </>
  );
};

export default RisorseTaskList;
